// No posthog import: the e2e harness reads this from node to pre-decide consent
// in saved browser states. posthog-js stores the decision under this key as
// `1` (granted) or `0` (denied).
export const CONSENT_STORAGE_KEY = 'mentora_consent'
